'use strict';

var App = require('app');

var MiscInfo = Backbone.Model.extend({
    url: function () {
        return '/api/v1/devices/' + this.id + '/metadata';
    },
});

var API = {
    getMiscInfo: function (deviceId) {
        var miscInfo = new MiscInfo({ id: deviceId });
        var defer = $.Deferred();

        miscInfo.fetch({
            success: function (data) {
                defer.resolve(data);
            },
            error: function () {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('miscinfo:model', function (deviceId) {
    return API.getMiscInfo(deviceId);
});

module.exports = MiscInfo;
